import React, { useCallback, useEffect, useRef, useState } from "react";
import Header from "../../../Header";
import AgGridComponent from "./components/AgGridComponent";
import LeadsListingTopFilter from "./components/LeadsListingTopFilter";
import Dropdown from "rsuite/esm/Dropdown";
import CreateFreeTrialParent from "./components/CreateFreeTrialParent";
import EndUserTestCredentails from "./components/EndUserTestCredentails";
// import { toast } from "react-toastify";
import CreateLeadModal from "./components/CreateLeadModal";
import CustomerMapDrawer from "./components/CustomerMapDrawer";
import { apiRequest } from "../../../utils/utils";
import { BsSearch } from "react-icons/bs";
import ColumnOrderManager from "./components/ColumnOrderManager";
import { getCookie, sanitizeFilters } from "../../common/Utility";
import {
  clearLocalStorage,
  getFromLocalStorage,
  storeToLocalStorage,
} from "../../../utils/storeLocalStorage";
import toast, { Toaster } from "react-hot-toast";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import BulkEdit from "./components/BulkEdit";

import { Link } from "react-router-dom/cjs/react-router-dom.min";

const CrmLeadsList = () => {
  let user_uuid =
    getCookie("muvi_useruuid") || "45cfe77780ec435cb7ba63618e013baa";
  const { attribute_set_key, share_id: sharedFilterId } = useParams();
  // const [attribute_set_key, setAttribute_set_key] = useState("");
  const [createTrialModalOpen, setCreateTrialModalOpen] = useState(false);
  const [createLeadModalOpen, setCreateLeadModalOpen] = useState(false);
  const [columnsDef, setColumnsDef] = useState([]);
  const [allcolumnsDef, setAllColumnsDef] = useState([]);
  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [quickFilters, setQuickFilters] = useState([]);
  const [appToken, setAppToken] = useState("");
  const [formData, setFormData] = useState({
    customerName: "",
    companyName: "",
    phoneNumber: "",
    emailId: "",
    password: "",
    products: [],
  });
  const [apiUrl, setApiUrl] = useState("");
  // const [emailModalOpen, setEmailModalOpen] = useState(false);
  const [testCredentials, setTestCredentials] = useState({
    email: "",
    password: "",
  });
  const [testCredentialModalOpen, setTestCredentialModalOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const [productData, setProductData] = useState([]);
  const [state, setState] = useState({
    customerMapHeader: false,
    totalCount: 0,
    isFilterChanges: false,
    search: "",
    aggridData: {
      app_token: process.env.REACT_APP_tattle_token,
      columnsApi: `${process.env.REACT_APP_tattle_api}/tattle/list`,
      rowsApi: `${process.env.REACT_APP_CRM_ADMIN}/api/crm/list`,
      attribute_set_key: attribute_set_key,
      search: "",
      syncFilterWithAggrid: {},
      sort: "created_date",
      order: "desc",
      actions: {},
      loadColumns: false,
      advFilters: [],
      refetchGrid: false,
    },
    hiddenColumns: [],
    searchAttributeColumns: "",
    filters: {},
    columnsValueSearch: { key: "", value: "" },
    moreButton: true,
    advanceFilter: false,
    advanceFilterData: [],
  });

  const [search, setSearch] = useState("");
  const [advanceFilter, setAdvanceFilter] = useState(false);
  const [editFilter, setEditFilter] = useState(null);
  const [columnsValueSearch, setColumnsValueSearch] = useState({
    key: "",
    value: "",
  });
  const [selectedFilter, setSelectedFilter] = useState(null);
  const [selectedContactFilter, setSelectedContactFilter] = useState(null);
  const [filterList, setFilterList] = useState([]);
  // const [contactFilterList, setContactFilterList] = useState([]);
  const [deleteConfirm, setDeleteConfirm] = useState(null);
  const [isPublic, setIsPublic] = useState(false);
  const [filters, setFilters] = useState([
    { field: "", condition: "eq", value: "" },
  ]);
  // const [sharedFilterId, setSharedFilterId] = useState(null);
  const [selectedLeads, setSelectedLeads] = useState([]);
  const [userList, setUserList] = useState([]);

  const [localRestored, setLocalRestored] = useState(false);

  useEffect(() => {
    document.title = `Intranet | ${attribute_set_key.charAt(0).toUpperCase() + attribute_set_key.slice(1)}`;
  }, []);

  const getUserList = useCallback(async () => {
    const responseData = await apiRequest(
      process.env.REACT_APP_CRM + "/user-list",
      "POST",
      {},
    );
    if (responseData && responseData.data) {
      const redata = Object.values(responseData.data).map((it) => ({
        label: it.name,
        value: it.user_uuid,
        ...it,
      }));

      setUserList(redata);
    }
  }, []);

  const onSelectionChange = (selectedData) => {
    const ids = selectedData
      .filter((item) => item && item.mautic_id)
      .map((item) => item.mautic_id);
    setSelectedLeads(ids);
  };

  const gridRef = useRef(null);

  const handleCancelSelection = () => {
    if (gridRef.current && gridRef.current.api) {
      gridRef.current.api.deselectAll();
    }
    setSelectedLeads([]);
  };



  const getSharedFilter = async (filterId) => {
    try {
      const response = await apiRequest(
        `${process.env.REACT_APP_tattle_api}/get-custom-filter/?filter_id=${filterId}`,
        "GET",
      );
      if (response.code === 200) {
        setTimeout(() => {
          setState((prev) => ({
            ...prev,
            filters: {},
          }));

          setFilters([{ field: "", condition: "eq", value: "" }]);

          const data = response.data;
          if (!data) return;

          const parsedFilters = JSON.parse(data.filter_value);

          const { advance_filter, ...output_adv_filter } = parsedFilters;

          if (advance_filter) {
            // const processedAdvanceFilter = Object.values(advance_filter).flat();
            const processedAdvanceFilter = sanitizeFilters(advance_filter);
            setFilters(processedAdvanceFilter);
          }

          // if (Object.keys(output_adv_filter).length) {
          setTimeout(() => {
            setState((prev) => ({
              ...prev,
              aggridData: {
                ...(prev.aggridData || {}),
                syncFilterWithAggrid: parsedFilters,
              },
              filters: output_adv_filter,
            }));
          }, 800);
          // }
          // This is true then AG API call will start
          setTimeout(() => {
            setLocalRestored(true);
          }, 900);

        }, 800);
      }
    } catch (error) {
      console.error("Error fetching shared filter:", error);
    }
  };

  const getProduct = async () => {
    const responseData = await apiRequest(
      `${process.env.REACT_APP_CRM}/crm/product/list`,
    );

    if (Array.isArray(responseData)) {
      const redata = responseData.map((item) => ({
        label: item.product_name,
        value: item.product_key,
        data: item,
        id: item.product_key,
      }));

      setProductData(redata);
    }
  };
  useEffect(() => {
    getProduct();
    getUserList();
  }, []);

  const callfunctionapi = async () => {
    const { columnsApi, app_token } = state.aggridData;
    let requestdata = {
      app_token,
      attribute_set_key: attribute_set_key,
      user_uuid: user_uuid ? user_uuid : "45cfe77780ec435cb7ba63618e013baa",
    };
    const rdata = await apiRequest(columnsApi, "POST", requestdata);

    if (rdata.code === 200) {
      const { columns, hidden_columns } = rdata.data;
      const finalcol = columns.concat(hidden_columns || []);
      setColumnsDef(finalcol);
      const visibleColumns = finalcol.filter((col) => !col.hide_col);
      setAllColumnsDef(visibleColumns);
      const hiddenColumns = (hidden_columns || []).map((item) => item.field);
      setHiddenColumns(hiddenColumns);
    }
  };
  const initialRender = useRef(true);

  useEffect(() => {
    if (!attribute_set_key) return;
    if (initialRender.current) {
      initialRender.current = false;
      return;
    }
    (async () => {
      callfunctionapi();
    })();
  }, [state.aggridData.refetchGrid]);



  useEffect(() => {
    if (sharedFilterId) {
      getSharedFilter(sharedFilterId);
    }
  }, [sharedFilterId]);


  const restoreTimerRef = useRef(null);
  const activeAttrKeyRef = useRef(null);

  useEffect(() => {
    if (sharedFilterId) return;

    activeAttrKeyRef.current = attribute_set_key;


    // clear any pending restore
    if (restoreTimerRef.current) {
      clearTimeout(restoreTimerRef.current);
    }
    setState((prev) => ({
      ...prev,
      aggridData: {
        ...(prev.aggridData || {}),
        syncFilterWithAggrid: {},
        advFilters: [],
      },
      filters: {},
      columnsValueSearch: { key: "", value: "" },
      advanceFilter: false,
      advanceFilterData: [],
    }));

    restoreTimerRef.current = setTimeout(() => {
      const local_filters = getFromLocalStorage(
        `crm_${attribute_set_key}_list`,
      );
      const local_my_filter = getFromLocalStorage(
        `crm_${attribute_set_key}_filter_2`,
      );
      const local_contact_filter = getFromLocalStorage(
        `crm_${attribute_set_key}_filter_1`,
      );
  

      // reset first
      setFilters([{ field: "", condition: "eq", value: "" }]);

      setSelectedFilter(null);
      setSelectedContactFilter(null);

      if (local_filters) {
        const parsedFilters = JSON.parse(local_filters);
        const { advance_filter, ...output_adv_filter } = parsedFilters;

        setState((prev) => {
          return {
            ...prev,
            aggridData: {
              ...(prev.aggridData || {}),
              syncFilterWithAggrid: parsedFilters,
            },
            filters: {
              ...(prev.filters || {}),
              ...output_adv_filter,
            },
          };
        });

        if (Array.isArray(advance_filter) && advance_filter.length) {
          setTimeout(() => {
            setFilters(advance_filter);
          }, 800);
        }
      }

      if (local_my_filter) {
        setSelectedFilter(JSON.parse(local_my_filter));
      }

      if (local_contact_filter) {
        setSelectedContactFilter(JSON.parse(local_contact_filter));
      }
      activeAttrKeyRef.current = attribute_set_key;
    }, 800);

    setTimeout(() => {
      isRestoringRef.current = false;
      setLocalRestored(true);
    }, 900);
    return () => {
      if (restoreTimerRef.current) {
        clearTimeout(restoreTimerRef.current);
      }
    };
  }, [attribute_set_key, sharedFilterId]);

  const firstFilter1 = useRef(true);
  const firstFilter2 = useRef(true);
  const crm_list_ref = useRef(true);

  const filter2DebounceRef = useRef(null);

  useEffect(() => {
    if (firstFilter2.current) {
      firstFilter2.current = false;
      return;
    }

    // Clear previous pending save
    if (filter2DebounceRef.current) {
      clearTimeout(filter2DebounceRef.current);
    }

    // Set new debounce timer (2 seconds)
    filter2DebounceRef.current = setTimeout(() => {
      storeToLocalStorage(
        JSON.stringify(selectedFilter),
        `crm_${attribute_set_key}_filter_2`
      );
    }, 3000);

    // Cleanup on unmount or re-run
    return () => {
      if (filter2DebounceRef.current) {
        clearTimeout(filter2DebounceRef.current);
      }
    };

  }, [selectedFilter]);


  useEffect(() => {
    if (advanceFilter === true && editFilter === null) {
      const timer = setTimeout(() => {
        setState((prev) => {
          const prevFilters =
            prev.aggridData &&
            prev.aggridData.syncFilterWithAggrid &&
            prev.aggridData.syncFilterWithAggrid.advance_filter;

          return {
            ...prev,
            filters: {}, // reset top-level filters
            aggridData: {
              ...prev.aggridData,
              syncFilterWithAggrid: {
                advance_filter: prevFilters || [],
              },
            },
          };
        });
      }, 800);

      // cleanup (important if dependencies change fast)
      return () => clearTimeout(timer);
    }
  }, [advanceFilter, editFilter]);

  useEffect(() => {
    setState((prev) => ({
      ...prev,
      aggridData: {
        ...prev.aggridData,
        attribute_set_key,
      },
    }));
    refetchGrid();
  }, [attribute_set_key]);

  const listDebounceRef = useRef(null);
  const crmFirstRender = useRef(true);
  const isRestoringRef = useRef(true);


  useEffect(() => {
    if (Object.keys(state.aggridData.syncFilterWithAggrid).length) {
      // store to locastorage
      const jsonString = JSON.stringify(state.aggridData.syncFilterWithAggrid);

      if (crm_list_ref.current) {
        crm_list_ref.current = false;
        return;
      }
      if (isRestoringRef.current) return;
      if (listDebounceRef.current) {
        clearTimeout(listDebounceRef.current);
      }
      if (!crmFirstRender.current) {
        listDebounceRef.current = setTimeout(() => {
          localStorage.setItem(
            `crm_${attribute_set_key}_list`,
            jsonString
          );
        }, 800);
      }
      crmFirstRender.current = false;



      const keys = Object.keys(state.aggridData.syncFilterWithAggrid).filter(
        (key) => state.aggridData.syncFilterWithAggrid[key] !== "",
      );
      keys.forEach((item) => {
        let idfind = document.querySelector(
          `.ag-layout-normal .ag-header-row [col-id="${item}"]`,
        );
        requestAnimationFrame(() => {
          if (idfind) {
            idfind.querySelectorAll("svg path").forEach((it) => {
              it.style.stroke = "#18A0FB";
              it.style.fill = "#18A0FB";
            });
          }
        });
      });
      return () => {
        if (listDebounceRef.current) {
          clearTimeout(listDebounceRef.current);
        }
      };
    }
  }, [state.aggridData.syncFilterWithAggrid, state.isFilterChanges]);

  useEffect(() => {
    if (state.aggridData.loadColumns) {
      setTimeout(() => {
        setState((state) => ({
          ...state,
          aggridData: {
            ...state.aggridData,
            loadColumns: false,
          },
        }));
      }, 0);
    }
  }, [state.aggridData.loadColumns]);

  useEffect(() => {
    setTimeout(() => {
      setCopied(false);
    }, 3000);
  }, [copied]);

  const debounceFilter1Ref = useRef(null);


  useEffect(() => {
    let found = null;

    if (
      quickFilters &&
      quickFilters.owner &&
      Array.isArray(quickFilters.owner) &&
      quickFilters.owner[0] &&
      quickFilters.owner[0].options &&
      Array.isArray(quickFilters.owner[0].options)
    ) {
      found = quickFilters.owner[0].options.find(function (f) {
        return f.value === selectedContactFilter;
      });
    }

    const fval =
      found && found.filter_value
        ? found.filter_value
        : {
          unassigned_owners: "",
          unassigned_sales: "",
          muvi_ownership: "",
        };

    //  Apply filter immediately
    filterOnchangeData(fval, "me");

    // Debounce only localStorage
    if (attribute_set_key) {
      if (firstFilter1.current) {
        firstFilter1.current = false;
        return;
      }

      if (debounceFilter1Ref.current) {
        clearTimeout(debounceFilter1Ref.current);
      }

      debounceFilter1Ref.current = setTimeout(() => {

        storeToLocalStorage(
          JSON.stringify(selectedContactFilter),
          `crm_${attribute_set_key}_filter_1`
        );
      }, 3000);
    }

    return () => {
      if (debounceFilter1Ref.current) {
        clearTimeout(debounceFilter1Ref.current);
      }
    };
  }, [selectedContactFilter]);


  const filterOnchangeData = (val, key = null) => {

    //  1. Handle search separately — return early
    if (key === "search") {
      setState((state) => ({
        ...state,
        aggridData: {
          ...state.aggridData,
          search: val || "",
        },
      }));
      let filtercopy = { ...state.filters };
      syncFilterWithAggrid(filtercopy);

      return;
    }

    let filtercopy = { ...state.filters };

    if (key === "me") {
      const obj = Array.isArray(val) ? val[0] : val;

      if (obj && typeof obj === "object") {
        Object.entries(obj).forEach(([k, v]) => {
          let value = v;

          // If value contains the placeholder → replace it
          if (typeof value === "string" && value.includes("__MYUUID__")) {
            value = value.replace("__MYUUID__", user_uuid);
          }

          // If value is an array → replace inside array
          if (Array.isArray(value)) {
            value = value.map((item) =>
              typeof item === "string" && item.includes("__MYUUID__")
                ? item.replace("__MYUUID__", user_uuid)
                : item,
            );
          }

          if (value) filtercopy[k] = value;
          else delete filtercopy[k];
        });
      }
    }

    // 🔹 3. Handle created_date range merge
    else if (key === "created_date") {
      const newdate = val
        ? val.map((date) => {
          const d = new Date(date);
          d.setDate(d.getDate() + 1);
          return d.toISOString().split("T")[0];
        })
        : [];

      filtercopy = {
        ...filtercopy,
        range: {
          ...(filtercopy.range || {}),
          created_date: newdate,
        },
      };
    } else {
      filtercopy = {
        ...filtercopy,
        [key]: val,
      };
    }

    // 🔹 4. Sync & update
    syncFilterWithAggrid(filtercopy);

    setState((state) => ({
      ...state,
      filters: {
        ...state.filters,
        ...filtercopy,
      },
    }));
  };

  const refetchGrid = () => {
    setState((state) => ({
      ...state,
      aggridData: {
        ...state.aggridData,
        refetchGrid: !state.aggridData.refetchGrid,
      },
    }));
  };
  const refetchAgGrid = () => {
    setState((state) => ({
      ...state,
      aggridData: {
        ...state.aggridData,
        syncFilterWithAggrid: {
          ...state.aggridData.syncFilterWithAggrid,
          refetchGrid: true,
        },
      },
    }));
  };

  const syncFilterWithAggrid = (filterdata) => {
    let newfilterdata = {};
    if (filterdata && filterdata.hasOwnProperty("search")) {
      newfilterdata = { search: filterdata.search };
    } else {
      newfilterdata = filterdata;
    }
    setState((state) => {
      return {
        ...state,
        aggridData: {
          ...state.aggridData,
          syncFilterWithAggrid: filterdata,
        },
      };
    });
  };

  const setAgGridLoadColumns = (val) => {
    setState((state) => ({
      ...state,
      aggridData: {
        ...state.aggridData,
        loadColumns: val,
      },
    }));
  };

  const resetFilters = () => {
    setState((state) => {
      return {
        ...state,
        filters: {},
        aggridData: {
          ...state.aggridData,
          syncFilterWithAggrid: { advance_filter: {} },
        },
      };
    });
    handleCancelSelection();
    clearLocalStorage(`crm_${attribute_set_key}_filter_2`);
    clearLocalStorage(`crm_${attribute_set_key}_list`);
    clearLocalStorage(`crm_${attribute_set_key}_adv_filter`);
    clearLocalStorage(`crm_${attribute_set_key}_filter_1`);
  };

  const mailTriggerPopup = async (appToken) => {
    try {
      setCreateTrialModalOpen(false);
      setAppToken(appToken);
      const emailPayload = {
        username: formData.customerName,
        email: formData.emailId,
        login_url: process.env.REACT_APP_LOGIN_URL,
        password: formData.password,
      };

      const response = await fetch(`${apiUrl}/CrmRest/FreeTrialSuccess`, {
        method: "POST",
        body: JSON.stringify(emailPayload),
      });

      const successResult = await response.json();

    } catch (error) {
      console.error("Error triggering mail popup:", error);
    }
  };

  const fetchTestCredentials = async () => {
    try {
      const apiUrl = `${process.env.REACT_APP_CRM}/crm/get-test-credentials`;
      const response = await fetch(apiUrl, { method: "GET" });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();

      if (data.code === 200 && data.data) {
        setTestCredentials({
          email: data.data.email || "",
          password: data.data.password || "",
        });
      } else {
        console.warn(
          "No credentials found or an error occurred:",
          data.message,
        );
        setTestCredentials({ email: "", password: "" });
      }
    } catch (error) {
      console.error("Failed to fetch test credentials:", error.message);
    }
  };

  const handleTestCredentialClick = async () => {
    await fetchTestCredentials();
    setTestCredentialModalOpen(true);
  };

  const handleCopy = () => {
    const credentialsText = `Email: ${testCredentials.email}\nPassword: ${testCredentials.password}`;
    navigator.clipboard.writeText(credentialsText).then(
      () => {
        setCopied(true);
      },
      (err) => {
        toast.success("Failed to copy text.");
        console.error("Failed to copy text: ", err);
      },
    );
  };

  const showCustomerMap = () => {
    setState((state) => {
      return {
        ...state,
        customerMapHeader: true,
      };
    });
  };

  const showCustomerMapClose = () => {
    setState((state) => {
      return {
        ...state,
        customerMapHeader: false,
      };
    });
  };

  function convertFilterResponse(resp) {
    const finalData = [];
    // Push system items first
    if (Array.isArray(resp.system)) {
      resp.system.forEach((item) => {
        if (Array.isArray(item.options)) {
          finalData.push(...item.options);
        }
      });
    }

    const customOptions = Array.isArray(resp.system)
      ? resp.custom.flatMap((item) => item.options || [])
      : resp.custom && Array.isArray(resp.custom.options)
        ? resp.custom.options
        : [];

    if (customOptions.length > 0) {
      finalData.push({
        label: "",
        value: "separator_custom",
        type: "separator",
        disabled: true,
      });

      finalData.push(...customOptions);
    }

    finalData.sort(function (a, b) {
      if (a.type === "system" && b.type !== "system") return -1;
      if (a.type !== "system" && b.type === "system") return 1;

      if (a.type === "custom" && b.type !== "custom") return 1;
      if (a.type !== "custom" && b.type === "custom") return -1;

      return 0;
    });


    return finalData;
  }

  const fetchFilters = async () => {
    const payload = {
      app_token: process.env.REACT_APP_tattle_token,
      attribute_set_key,
      user_uuid: user_uuid || "45cfe77780ec435cb7ba63618e013baa",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_tattle_api}/filter/list`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      if (!response.ok) {
        console.error("API error:", response);
      }

      const data = await response.json();

      if (data.code || data.code == 200) {
        // setContactFilterList(data.data.contact);
        setQuickFilters(data.data);
        const finalArray = convertFilterResponse(data.data);
        setFilterList(finalArray);
        setDeleteConfirm(null);
      }
    } catch (err) {
      console.error("Save filter failed:", err);
      // Optionally show some error UI to the user
    }
  };

  return (
    <React.Fragment>
      <Header
        brecum_name="CRM"
        brecum_page={
          attribute_set_key.charAt(0).toUpperCase() + attribute_set_key.slice(1)
        }
      />
      <Toaster
        toastOptions={{
          duration: 3000,
          position: "bottom-left",
        }}
      />
      <div className="right_col listing-page">
        <div className="customer-wrap">
          <div className="page-top" style={{ padding: "16px 0 5px" }}>
            <div className="containerfull">
              <div className="row align-items-center">
                <div className="col-md-12">
                  <div>
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center title">
                        <h2>
                          {attribute_set_key.charAt(0).toUpperCase() +
                            attribute_set_key.slice(1)}{" "}
                          {state.totalCount && (
                            <span className="badge-blue">
                              {state.totalCount}
                            </span>
                          )}
                        </h2>
                      </div>

                      {/* Right: Search + Dropdown */}
                      <div className="d-flex align-items-center">
                        {/* Search box */}
                        <div
                          className="lct-form-group d-flex align-items-center"
                          style={{
                            height: "37px",
                            width: "300px",
                            background: "#fff",
                            borderRadius: "6px",
                            border: "1px solid #ccc",
                            padding: "0 8px",
                          }}
                        >
                          <BsSearch color="#555" />
                          <input
                            placeholder="Search"
                            type="text"
                            className="form-control border-0 shadow-none"
                            name="search"
                            id="search"
                            autoComplete="off"
                            onChange={(e) => setSearch(e.target.value)}
                            value={search || ""}
                            style={{
                              height: "35px",
                              paddingLeft: "8px",
                              background: "transparent",
                            }}
                          />
                        </div>
                        <ColumnOrderManager
                          refetchGrid={refetchGrid}
                          setAgGridLoadColumns={callfunctionapi}
                          columnsValueSearch={columnsValueSearch}
                          setColumnsValueSearch={setColumnsValueSearch}
                          attribute_set_key={attribute_set_key}
                          columnsDef={allcolumnsDef}
                          hiddenColumns={hiddenColumns}
                          setHiddenColumns={setHiddenColumns}
                        />
                        {attribute_set_key === "contacts" ? (
                          <React.Fragment>
                            <div
                              class="toogle-btn"
                              onClick={() => showCustomerMap()}
                              style={{ height: "37px" }}
                            >
                              <span>
                                <svg
                                  stroke="currentColor"
                                  fill="none"
                                  stroke-width="2"
                                  viewBox="0 0 24 24"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  height="16"
                                  width="16"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path>
                                  <circle cx="12" cy="10" r="3"></circle>
                                </svg>
                              </span>
                            </div>

                            {/* Dropdown */}
                            <Dropdown
                              title="Actions"
                              className="custom-action-dropdown"
                              placement="bottomEnd"
                              style={{ marginLeft: "10px" }}
                            >
                              <Dropdown.Item
                                onClick={() => {
                                  setCreateTrialModalOpen(true);
                                }}
                              >
                                Create Trial Account
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => {
                                  setCreateLeadModalOpen(true);
                                }}
                              >
                                Create New Lead
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={handleTestCredentialClick}
                              >
                                End User Test Credential
                              </Dropdown.Item>
                            </Dropdown>
                          </React.Fragment>
                        ) : attribute_set_key === "deals" ? (
                          <div style={{ marginLeft: ".5rem" }}>
                            <Link
                              to="/deals/add"
                              className="btn btn-sky mob"
                              style={{ height: "37px" }}
                            >
                              <span className="hidden-sm">Add New Deal</span>
                              <span className="mob_icon_plus hidden-md"></span>
                            </Link>
                          </div>
                        ) : (
                          <React.Fragment></React.Fragment>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <CreateFreeTrialParent
                  show={createTrialModalOpen}
                  mailTriggerPopup={mailTriggerPopup}
                  formData={formData}
                  setFormData={setFormData}
                  apiUrl={apiUrl}
                  setApiUrl={setApiUrl}
                  productOptions={productData}
                  setModalOpen={setCreateTrialModalOpen}
                />
                <CreateLeadModal
                  showModal={createLeadModalOpen}
                  setShowModal={setCreateLeadModalOpen}
                  productData={productData}
                />
                <EndUserTestCredentails
                  testCredentials={testCredentials}
                  handleCopy={handleCopy}
                  copied={copied}
                  show={testCredentialModalOpen}
                  close={() => setTestCredentialModalOpen(false)}
                />
              </div>
              <LeadsListingTopFilter
                filters={state.filters}
                columnsDef={columnsDef}
                onFilterChange={filterOnchangeData}
                syncFilterWithAggrid={syncFilterWithAggrid}
                setAgGridLoadColumns={setAgGridLoadColumns}
                resetFilters={resetFilters}
                productData={productData}
                setProductData={setProductData}
                showCustomerMap={showCustomerMap}
                setState={setState}
                search={search}
                setSearch={setSearch}
                refetchGrid={refetchGrid}
                columnsValueSearch={columnsValueSearch}
                setColumnsValueSearch={setColumnsValueSearch}
                editFilter={editFilter}
                setEditFilter={setEditFilter}
                selectedFilter={selectedFilter}
                setSelectedFilter={setSelectedFilter}
                filterList={filterList}
                fetchFilters={fetchFilters}
                deleteConfirm={deleteConfirm}
                setDeleteConfirm={setDeleteConfirm}
                advanceFilter={advanceFilter}
                setAdvanceFilter={setAdvanceFilter}
                isPublic={isPublic}
                setIsPublic={setIsPublic}
                attribute_set_key={attribute_set_key}
               
                advfilters={filters}
                setFilters={setFilters}
                aggridData={state.aggridData}
                sharedFilterId={sharedFilterId}
                allcolumnsDef={allcolumnsDef}
               
                quickFilters={quickFilters}
                selectedContactFilter={selectedContactFilter}
                setSelectedContactFilter={setSelectedContactFilter}
              />
            </div>
          </div>
          <div className="">
            <BulkEdit
              columnsDef={columnsDef}
              userList={userList}
              selectedLeads={selectedLeads}
              onCancel={handleCancelSelection}
              refetchGrid={refetchAgGrid}
              attribute_set_key={attribute_set_key}
            />
          </div>
          <div class="body-content">
            <AgGridComponent
              ref={gridRef}
              agData={state.aggridData}
              encrypt={false}
              userList={userList}
              storePermission={1}
              getTotalCount={setState}
              isLeadsDetailsPage={true}
              hasChildRows={true}
              callfunctionapi={callfunctionapi}
              columnsDef={columnsDef}
              productData={productData}
              selection={true}
              onSelectionChange={onSelectionChange}
              // action={true}
              refetchAgGrid={refetchAgGrid}
              localRestored={localRestored}
             
            />
          </div>
        </div>
      </div>
      <CustomerMapDrawer
        showCustomerMapFlag={state.customerMapHeader}
        showCustomerMapClose={showCustomerMapClose}
      />
    </React.Fragment>
  );
};

export default CrmLeadsList;



// WEBPACK FOOTER //
// ./src/components/crm/leads/CrmLeadsList.js